import { Action } from './Action.js';
import i18next from "i18next";

/**
 * @class AddToTrend
 * @extends Action
 * @classdesc Действие добавить на тренд
 * */
export class AddToTrend extends Action {	
    execute(context) {
        const trends = document.querySelectorAll('ms-trend')
        const data = this.data;
        data.PenName = this.calcParam(data.PenName, context);
        if(trends.length){
            if(trends.length === 1){
                trends[0].addToTrend(data)
            } else {
                let parentElement = context.currentTarget.parentElement
                let done = false
                while(parentElement !== document.body && !done){
                    const trends = parentElement.querySelectorAll('ms-trend')
                    if(trends.length){
                        done = true
                        trends[0].addToTrend(data)
                    }
                    parentElement = parentElement.parentElement
                }
            }
        } else {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t('add_to_trend_error'),
                text: i18next.t("trend_not_found"),               
            });
        }
	}
    get data() {
        let penName = this.Pen?.value;
        if (penName && penName.startsWith('.')) {
            let path = $sw.ItemSubscription._getOuterPath(this.context);
            let objectid = $sw.ItemSubscription._getParentParam(this.context, 'objectid', true);
            let fullName = $pr.getFullName(objectid);
            if (path)
                path = $pr.getFullNameByLuaName(fullName, path);            
            else
                path = "";
            penName = fullName + path + penName;
        }
        
        return { PenName: penName, Title: this.Title?.value}
    }
}